export default __webpack_public_path__ + "static/media/p3.c1cb6bfa.jpeg";